import React from "react";

const Settings = () => {
  return <div>Hello from Settings</div>;
};

export default Settings;
